import axios from '../../../api/axios';

const BASE = '/v1/mailboxes';

export const emailOutreachApi = {
  // Access check
  getAccess: async () => {
    const res = await axios.get(`${BASE}/access`);
    return res.data;
  },

  // Mailboxes
  getMailboxes: async () => {
    const res = await axios.get(BASE);
    return res.data;
  },

  connectGoogle: async (clientRedirect = '') => {
    const res = await axios.post(`${BASE}/connect/google`, { clientRedirect });
    return res.data;
  },

  disconnectMailbox: async (id) => {
    const res = await axios.delete(`${BASE}/${id}`);
    return res.data;
  },

  syncMailbox: async (id) => {
    const res = await axios.post(`${BASE}/${id}/sync`);
    return res.data;
  },

  syncAllMailboxes: async () => {
    const res = await axios.post(`${BASE}/sync`);
    return res.data;
  },

  // Sequences
  listSequences: async () => {
    const res = await axios.get(`${BASE}/sequences`);
    return res.data;
  },

  getSequence: async (id) => {
    const res = await axios.get(`${BASE}/sequences/${id}`);
    return res.data;
  },

  createSequence: async ({ name, steps }) => {
    const res = await axios.post(`${BASE}/sequences`, { name, steps });
    return res.data;
  },

  updateSteps: async (id, steps) => {
    const res = await axios.put(`${BASE}/sequences/${id}/steps`, { steps });
    return res.data;
  },

  assignMailbox: async (id, connectionId) => {
    const res = await axios.patch(`${BASE}/sequences/${id}/mailbox`, { connectionId });
    return res.data;
  },

  setSequenceStatus: async (id, status) => {
    const res = await axios.post(`${BASE}/sequences/${id}/status`, { status });
    return res.data;
  },

  enrollContact: async (id, { contactEmail, leadId, timezone }) => {
    const res = await axios.post(`${BASE}/sequences/${id}/enroll`, {
      contactEmail,
      leadId,
      timezone,
    });
    return res.data;
  },

  // Replies & Triage
  listReplies: async ({ classification, limit = 50 } = {}) => {
    const params = {};
    if (classification && classification !== 'all') params.classification = classification;
    if (limit) params.limit = limit;
    const res = await axios.get(`${BASE}/replies`, { params });
    return res.data;
  },

  reviewReply: async (id, classification) => {
    const res = await axios.patch(`${BASE}/replies/${id}/classification`, { classification });
    return res.data;
  },

  generateReplyDraft: async (id, { instructions } = {}) => {
    const res = await axios.post(`${BASE}/replies/${id}/draft`, { instructions });
    return res.data;
  },

  sendReply: async (id, { connectionId, subject, body } = {}) => {
    const res = await axios.post(`${BASE}/replies/${id}/send`, { connectionId, subject, body });
    return res.data;
  },

  // Deliverability
  getDeliverabilityStats: async ({ days = 30 } = {}) => {
    const res = await axios.get(`${BASE}/deliverability`, { params: { days } });
    return res.data;
  },

  // Template Governance & Compliance (FR-M07-008)
  getComplianceProfile: async () => {
    const res = await axios.get(`${BASE}/compliance-profile`);
    return res.data;
  },

  updateComplianceProfile: async (profileData) => {
    const res = await axios.put(`${BASE}/compliance-profile`, profileData);
    return res.data;
  },

  listTemplates: async ({ status, category, useCase, limit = 50 } = {}) => {
    const params = {};
    if (status && status !== 'all') params.status = status;
    if (category && category !== 'all') params.category = category;
    if (useCase) params.useCase = useCase;
    if (limit) params.limit = limit;
    const res = await axios.get(`${BASE}/templates`, { params });
    return res.data;
  },

  getTemplate: async (id) => {
    const res = await axios.get(`${BASE}/templates/${id}`);
    return res.data;
  },

  createTemplate: async (templateData) => {
    const res = await axios.post(`${BASE}/templates`, templateData);
    return res.data;
  },

  updateTemplate: async (id, updates) => {
    const res = await axios.put(`${BASE}/templates/${id}`, updates);
    return res.data;
  },

  submitTemplateForApproval: async (id) => {
    const res = await axios.post(`${BASE}/templates/${id}/submit`);
    return res.data;
  },

  approveTemplate: async (id) => {
    const res = await axios.post(`${BASE}/templates/${id}/approve`);
    return res.data;
  },

  rejectTemplate: async (id, reason) => {
    const res = await axios.post(`${BASE}/templates/${id}/reject`, { reason });
    return res.data;
  },

  deleteTemplate: async (id) => {
    const res = await axios.delete(`${BASE}/templates/${id}`);
    return res.data;
  },
};

export default emailOutreachApi;
